import '@zanichelli/albe-web-components/www/build/web-components-library.css';
import './index.css';

import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';

import { Provider } from 'react-redux';

import { Routes, Route } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';

import PageWrapper from './containers/page-wrapper';
import SolutionContainer from './containers/solution-container';
import ExerciseCorrectionPage from './containers/exercise-correction-page';
import ClassWorkPage from './containers/classwork';
import ClassWorkCorrectionPage from './containers/classwork-correction';
import ExercisePreviewPage from './containers/exercise-preview-page';

import { persistor, store } from './store';

import {
    CLASSWORK_LOGIN,
    CLASSWORK_LOGIN_CORRECTION,
    CORRECTION,
    EXERCISE_CORRECTION,
    EXERCISE_PREVIEW,
    OPEN_ASSIGNMENT,
    SOLUTION_PAGE,
} from './constants/routes';
import CorrectionPage from './containers/correction-page';

import { defineCustomElements } from '@zanichelli/albe-web-components/loader';
import LazeAssignmentPage from './containers/laze-assignment-page';
import StyleAndThemeProvider from './components/style-and-theme-provider';

defineCustomElements(window);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <StyleAndThemeProvider>
                <Router>
                    <Routes>
                        <Route path={SOLUTION_PAGE} element={<SolutionContainer />} />
                        <Route path={CORRECTION} element={<CorrectionPage />} />
                        <Route path={EXERCISE_CORRECTION} element={<ExerciseCorrectionPage />} />
                        <Route path={CLASSWORK_LOGIN} element={<ClassWorkPage />} />
                        <Route path={CLASSWORK_LOGIN_CORRECTION} element={<ClassWorkCorrectionPage />} />
                        <Route path={`${OPEN_ASSIGNMENT}/:assignmentUniqueCode`} element={<LazeAssignmentPage />} />
                        <Route path={`${EXERCISE_PREVIEW}/:exerciseId`} element={<ExercisePreviewPage />} />
                        <Route index path="/*" element={<PageWrapper />} />
                    </Routes>
                </Router>
            </StyleAndThemeProvider>
        </PersistGate>
    </Provider>,
);
